<div class="main">
    <div class="dx-field-title" translate>pgpKeys.pageTitle</div>
    <dx-data-grid #pgpKeys
                  [dataSource]="dataSource"
                  keyExpr="id"
                  [columnAutoWidth]="true"
                  [wordWrapEnabled]="true"
                  [focusedRowEnabled]="true"
                  height="calc(100vh - 150px)"
                  hoverStateEnabled="true"
                  [errorRowEnabled]="false"
                  (onContextMenuPreparing)="onContextMenuPreparing($event)"
                  (onRowDblClick)="displayPgpKey($event)">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-summary>
            <dxi-total-item column="name" [displayFormat]="'pgpKeys.lblPgpKeysCount' | translate" summaryType="count"></dxi-total-item>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="displayNewPopup()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>

        <!-- Standard columns -->
        <dxi-column dataField="name" [caption]="'pgpKeys.lblName' | translate"></dxi-column>
        <dxi-column dataField="hasPublicKey" [caption]="'pgpKeys.lblHasPublicKey' | translate"></dxi-column>
        <dxi-column dataField="hasPrivateKey" [caption]="'pgpKeys.lblHasPrivateKey' | translate"></dxi-column>
    </dx-data-grid>
</div>

<!-- Display popup -->
<dx-popup [title]="'pgpKeys.popupTitle' | translate" [height]="460" [(visible)]="isDisplayPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view id="scrollview" direction="vertical">
            <div class="dx-field">
                <div class="dx-field-label" translate>_commons.id</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [(value)]="displayedPgpKey.id"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>pgpKeys.lblName</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [(value)]="displayedPgpKey.name"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>pgpKeys.lblHasPublicKey</div>
                <div class="dx-field-value">
                    <dx-switch [readOnly]="true" [(value)]="displayedPgpKey.hasPublicKey"></dx-switch>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>pgpKeys.lblHasPrivateKey</div>
                <div class="dx-field-value">
                    <dx-switch [readOnly]="true" [(value)]="displayedPgpKey.hasPrivateKey"></dx-switch>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>pgpKeys.lblHasPrivateKeyPassword</div>
                <div class="dx-field-value">
                    <dx-switch [readOnly]="true" [(value)]="displayedPgpKey.hasPrivateKeyPassword"></dx-switch>
                </div>
            </div>
            <div class="flex bottom-buttons">
                <dx-button class="close" [text]="'_commons.close' | translate" (onClick)="this.isDisplayPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- New popup -->
<dx-popup [title]="'pgpKeys.popupTitle' | translate" [height]="650" [(visible)]="isNewPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isNewPopupVisible">
            <dx-validation-group #pgpKeyValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>
                        pgpKeys.lblName<span class="dx-field-item-required-mark">
                            *
                        </span>
                    </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedPgpKey.name">
                            <dx-validator>
                                <dxi-validation-rule type="required" [message]="'pgpKeys.msgNameRequired' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="stringLength" [max]="100" message="'_validators.maxLength100' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="isNew">
                    <div class="dx-field-label" translate>pgpKeys.lblPublicKey</div>
                    <div class="dx-field-value">
                        <dx-text-area [(value)]="selectedPgpKey.publicKey" [height]="150"></dx-text-area>
                    </div>
                </div>
                <div class="dx-field" *ngIf="isNew">
                    <div class="dx-field-label" translate>pgpKeys.lblPrivateKey</div>
                    <div class="dx-field-value">
                        <dx-text-area [(value)]="selectedPgpKey.privateKey" [height]="150"></dx-text-area>
                    </div>
                </div>
                <div class="dx-field" *ngIf="isNew">
                    <div class="dx-field-label" translate>pgpKeys.lblPrivateKeyPassword</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedPgpKey.privateKeyPassword" mode="password"></dx-text-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="add" [text]="'_commons.add' | translate" (onClick)="createPgpKey()"
                               [visible]="isNew"></dx-button>
                    <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updatePgpKey()"
                               [visible]="!isNew"></dx-button>
                    <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isNewPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Rename popup -->
<dx-popup [title]="'pgpKeys.popupTitle' | translate" [height]="250" [(visible)]="isRenamePopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isRenamePopupVisible">
            <dx-validation-group #pgpKeyRenameValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>
                        pgpKeys.lblName<span class="dx-field-item-required-mark">
                            *
                        </span>
                    </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedPgpKey.name">
                            <dx-validator>
                                <dxi-validation-rule type="required" [message]="'pgpKeys.msgNameRequired' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="stringLength" [max]="100" message="'_validators.maxLength100' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updatePgpKey()" [visible]="!isNew"></dx-button>
                    <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isRenamePopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Change public key popup -->
<dx-popup [title]="'pgpKeys.popupTitle' | translate" [height]="350" [(visible)]="isChangePublicKeyPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isChangePublicKeyPopupVisible">
            <dx-validation-group #pgpKeyChangePublicKeyValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>pgpKeys.lblPublicKey</div>
                    <div class="dx-field-value">
                        <dx-text-area [(value)]="selectedPgpKey.publicKey" [height]="150"></dx-text-area>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updatePublicKey()" [visible]="!isNew"></dx-button>
                    <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isChangePublicKeyPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Change private key popup -->
<dx-popup [title]="'pgpKeys.popupTitle' | translate" [height]="400" [(visible)]="isChangePrivateKeyPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isChangePrivateKeyPopupVisible">
            <dx-validation-group #pgpKeyChangePrivateKeyValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>pgpKeys.lblPrivateKey</div>
                    <div class="dx-field-value">
                        <dx-text-area [(value)]="selectedPgpKey.privateKey" [height]="150"></dx-text-area>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>pgpKeys.lblPrivateKeyPassword</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedPgpKey.privateKeyPassword" mode="password"></dx-text-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updatePrivateKey()" [visible]="!isNew"></dx-button>
                    <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isChangePrivateKeyPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
